export default class UpdateAdministratorSiteViewModel {
    public siteId: string = '';
    public organisationId: string = '';
}